const tmpAxis = new THREE.Vector3(0, 0, 1);
const tmpWorldScale = new THREE.Vector3();

function funDampedSine(amplitude, decay, frequency, phase, time) {
    return amplitude * (Math.E ** (-decay * time)) * Math.cos(frequency * time + phase);
}

function createSlideInAnim({ framerate, delay, duration, object, axis, amplitude, oscilations, decay }) {
    delay = 0;
    // delay = Q3.editMode ? 0 : delay;

    const delayOffset = Math.max(0, delay);
    const stepCount = framerate * duration;
    const timeStepSize = duration / (stepCount - 1);
    const valueStepSize = 1 / (stepCount - 1);
    const times = [], values = [];

    tmpWorldScale.set(1, 1, 1);

    let parent = object.parent;
    const tmpScale = new THREE.Vector3();

    while (parent) {
        if (!parent || !Q3.data.assets.objects[parent.uuid]) break;

        const animData = Q3.SlideManager.currentSlide.animation[parent.uuid];
        const { x: sx, y: sy, z: sz } = animData
            ? Q3.SlideManager.currentSlide.animation[object.uuid].scale
            : object.scale;

        tmpScale.set(sx, sy, sz);
        tmpWorldScale.multiply(tmpScale);
        parent = parent.parent;
    }

    const frequency = Math.PI * (Math.round(oscilations) + 0.5); // oscilations must be an integer otherwise the object will be out of phase at the end
    const phase = 0;
    const fx = t => funDampedSine(amplitude, decay, frequency, phase, t);
    const animData = Q3.SlideManager.currentSlide.animation[object.uuid];
    const { x: px, y: py, z: pz } = animData
        ? Q3.SlideManager.currentSlide.animation[object.uuid].position
        : object.position;
    const opos = new THREE.Vector3(px, py, pz);

    if (delay > 0) {
        const stepCount = framerate * delay;
        const timeStepSize = delay / stepCount;
        const y = Math.round(fx(valueStepSize) * 1000) / 1000;

        for (let i = 0; i < stepCount; i++) {
            const x = Math.round(i * timeStepSize * 1000) / 1000;

            tmpAxis
                .copy(axis)
                .normalize()
                .multiplyScalar(y)
                .divide(tmpWorldScale)
                .add(opos);
            times.push(x);
            values.push(...tmpAxis.toArray());
        }
    }

    for (let i = 0; i < stepCount; i++) {
        const x = Math.round(i * timeStepSize * 1000) / 1000;
        const y = Math.round(fx(i * valueStepSize) * 1000) / 1000;

        tmpAxis
            .copy(axis)
            .normalize()
            .multiplyScalar(y)
            .divide(tmpWorldScale)
            .add(opos);
        times.push(x + delayOffset);
        values.push(...tmpAxis.toArray());
    }

    const kfPosition = new THREE.VectorKeyframeTrack(".position", times, values);
    const tracks = [kfPosition];
    const clip = new THREE.AnimationClip(THREE.Math.generateUUID(), undefined, tracks);

    return clip;
}

export default createSlideInAnim;
export { createSlideInAnim };